import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import { ICartItem_Consultation } from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import { Col, Row } from "@/utils/bootstrap";
import ItemRemoveBtn from "./cart-item-btns/item-romove-btn/ItemRemoveBtn";
import Price from "@/app/components/lib/Price";
import ProductImg from "@/app/components/common-builder/product/product-box/product-box-helpers/product-box-image/ProductImg";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
interface Props {
  cartItem: ICartItem_Consultation;
}

const CartItemConsultation: React.FC<Props> = ({ cartItem }) => {
  const getCompanty = useGetCompanyQuery();
  const theme = getCompanty?.data?.result?.theme;
  return (
    <Row className="m-0 cart-item">
      <Col className="p-0 col-auto">
        <div className="cart-item-consut-img">
          <ProductImg
            discount={cartItem.discount}
            className="item-image-cart-container"
            imgWidth={96}
            imgHeight={96}
            src={cartItem?.thumbnail_url}
            size={Size.small}
            is_new={false}
            discount_amount={0}
            discount_type={undefined}
            has_discount={false}
            priority
            theme={theme!}
          />
        </div>
      </Col>
      <Col className="p-0">
        <h3 className="name m-0">{cartItem.name}</h3>
        <p className="consult-service-name m-0">
          {cartItem.others.message.slice(0, 50) + "...."}
        </p>
        <Row className="m-0 align-items-end">
          <Col className="p-0">
            <div className="price-line">
              <Price price={{ value: cartItem?.price, className: "price" }} />
            </div>
          </Col>
          <Col className="p-0 col-auto">
            <ItemRemoveBtn cartItemId={cartItem.id} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default CartItemConsultation;
